import React, { useState,useRef, useEffect } from 'react';
import { Formik, Form } from 'formik';
import get from 'lodash/get';
import * as Yup from 'yup';
import { numberFormat } from '../../../common/constants/NumberFormat';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import rupee_icon from '../../../images/icons/rupee_icon.svg';
import delete_icon from '../../../images/icons/AuditTrailIcons/delete_icon_black.svg';
import InputTypeFloat from '../../../common/components/InputTypeDecimalNumber/InputTypeFloat';
import _ from 'lodash';
import { EMICalculator } from '../../../common/constants/EMICalculator';

let OfferOptions = [
  {
    label: 'With Life Insurance',
    value: 'With Life Insurance',
    id: 1
  },
  {
    label: 'With Property Insurance',
    value: 'With Property Insurance',
    id: 2
  },
  {
    label: 'Both Life and Property Insurance',
    value: 'Both Life and Property Insurance',
    id: 3
  },
  {
    label: 'Without any Insurance',
    value: 'Without any Insurance',
    id: 4
  }
];
const validationSchema = Yup.object().shape({
  offerName: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  additionalAmount: Yup.string().required('Required'),
  rateOfInterestOffer: Yup.string()
    .required('Required')
    .test('rateOfInterestOffer', 'Can not be greater than 100%', function(val) {
      if (val != undefined) {
        let checkVal = parseInt(val.replace(/,/g, ''));
        if (checkVal >= 0 && checkVal <= 100) return true;
        else return false;
      }
    }),
  EMI: Yup.string().required('Required')
});

const AdditionalOffer = ({
  isDisplayMode,
  isAddMode,
  each,
  InPrincipalValue,
  randomColor,
  addNewOffer,
  setOfferData,
  onDeleteOffer,
  index,
  OfferValues,
  onSubmitAction
}) => {
  const [showEditDetele, setShowEditDelete] = useState(false);
  let colors = ['#e8fdff', '#eaecf9', '#fff0f8', '#fffadd'];

  const selectedOffers = useRef([]);

  useEffect(() => {
    if (InPrincipalValue?.loanOffers?.length) {
      selectedOffers.current = InPrincipalValue?.loanOffers?.map(
        offer => offer.offerType
      );
    }
  }, [InPrincipalValue?.loanOffers]);

  function getIntialValues() {
    let defaultObj = {
      loanAmountOffer: '',
      offerName: { value: '', label: 'Select' },
      additionalAmount: '',
      rateOfInterestOffer: '',
      EMI: ''
    };

    if (each) {
      return {
        loanAmountOffer: InPrincipalValue?.sanctionLoanAmount,
        offerName: { value: each?.offerType, label: each?.offerType },
        additionalAmount: each?.additionalAmount,
        rateOfInterestOffer: each?.rateOfInterestOffer,
        EMI: 0
      };
    }

    return {
      loanAmountOffer: InPrincipalValue?.sanctionLoanAmount,
      offerName: { value: '', label: 'Select' },
      additionalAmount: '',
      rateOfInterestOffer: '',
      EMI: ''
    };
  }

  return (
    <Formik
      initialValues={getIntialValues()}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        if (onSubmitAction) {
          onSubmitAction(values, actions);
        }
      }}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting
      }) => {
        const totalLoan = (
          parseInt(values?.loanAmountOffer) +
          parseFloat(values?.additionalAmount)
        ).toFixed(2);
        const InterestRate = parseFloat(values?.rateOfInterestOffer).toFixed(2);
        let loanTenure = '';
        if (InPrincipalValue?.tenureSelect.value == 'Year') {
          loanTenure = parseInt(InPrincipalValue?.loanTenure) * 12;
        } else {
          loanTenure = InPrincipalValue?.loanTenure;
        }
        const MonthlyEMI = EMICalculator(InterestRate, totalLoan, loanTenure);

        if (values?.EMI === '') {
          values.EMI = 0;
        } else {
          values.EMI = parseInt(MonthlyEMI);
        }

        ///////////
        return (
          <Form>
            {isAddMode && (
              <div className="bg-white py-8 md:py-1 p-2 ">
                <div className="flex-1  w-full">
                  <p className="font-roboto  text-black text-lg mb-5">
                    Add Additional Offer
                  </p>
                  <div className="pt-4 w-5/12">
                    <div className="grid grid-cols-2 ">
                      <div className="-mr-5">
                        <p className="text-gray-200 text-md ">Loan Amount :</p>
                      </div>
                      <div className="text-green-600 flex text-md">
                        <span className="pr-2">
                          <img
                            src={rupee_icon}
                            alt=""
                            className="xl:ml-0 ml-8"
                            style={{ maxWidth: '10px', paddingTop: '3px' }}
                          />
                        </span>{' '}
                        {numberFormat(parseInt(values?.loanAmountOffer))}
                      </div>
                    </div>
                  </div>
                  <div className="w-full pt-7">
                    <CommonSelect sort={true}
                      name="offerName"
                      value={values.offerName}
                      onChange={e => {
                        setFieldValue('offerName', {
                          value: e.value,
                          label: e.value
                        });
                      }}
                      onBlur={() => {
                        setFieldTouched('offerName', true, true);
                      }}
                      options={OfferOptions.filter(
                        offer => !selectedOffers.current.includes(offer.label)
                      )}
                      isHoverEffect
                      stylesContainer={{
                        marginBottom: '0px',
                        fontSize: '40px',
                        height: '52px'
                      }}
                      dropdownStyle={{
                        top: '52px',
                        color: 'rgba(0,0,0,0.87)',
                        fontSize: '16px',
                        backgroundColor: '#fff',
                        alignItems: 'center',
                        fontFamily: 'Roboto',
                        fontWeight: 400
                      }}
                      styleText={{
                        fontSize: '14px',
                        padding: '0 6px',
                        backgroundColor: 'white'
                      }}
                      error={
                        touched.offerName &&
                        get(errors, 'offerName.value', false)
                      }
                      touched={touched.offerName}
                    />
                  </div>
                  <div className="w-full pt-7">
                    <InputTypeNumber
                      name="additionalAmount"
                      value={values.additionalAmount}
                      maxLength={15}
                      minLength={0}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.additionalAmount && errors.additionalAmount
                      }
                      errorMsg={errors.additionalAmount}
                      touched={touched.additionalAmount}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      showInText={false}
                      legendName="Additional Amount"
                    />
                  </div>
                  <div className="w-full pt-7">
                    <InputTypeFloat
                      name="rateOfInterestOffer"
                      value={values.rateOfInterestOffer}
                      maxLength={10}
                      minLength={0}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      rupeeIcon={false}
                      error={
                        touched.rateOfInterestOffer &&
                        errors.rateOfInterestOffer
                      }
                      errorMsg={errors.rateOfInterestOffer}
                      touched={touched.rateOfInterestOffer}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      inputStyle={{
                        paddingLeft: '15px',
                        letterSpacing: '1px'
                      }}
                      legendStyle={{ paddingLeft: '5px' }}
                      legendName="Rate of Interest %"
                    />
                  </div>
                  <div className="pt-7 xl:w-8/12 w-full flex">
                    <div className="mr-0 w-2/12">
                      <p className="text-gray-200 text-sm py-4">EMI</p>
                    </div>
                    <div className="10/12">
                      <InputTypeNumber
                        name="EMI"
                        value={values.EMI}
                        maxLength={30}
                        minLength={0}
                        disabled={true}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        stylesContainer={{ minWidth: '280px' }}
                        error={touched.EMI && errors.EMI}
                        errorMsg={errors.EMI}
                        touched={touched.EMI}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        showInText={false}
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="submitButton text-14 w-40 h-12 font-medium font-roboto"
                    disabled={!_.isEmpty(errors)}
                  >
                    Add
                  </button>
                </div>
              </div>
            )}
            {isDisplayMode && (
              <React.Fragment>
                <div style={{ background: colors[index] }}>
                  <div className="relative">
                    <span className="block p-1 pl-2 pr-6 h-12">
                      {each?.offerType}
                    </span>
                    <div
                      className="text-2xl font-medium relative h-0 cursor-pointer float-right"
                      onClick={e => {
                        e.stopPropagation();
                        setShowEditDelete(!showEditDetele);
                      }}
                      style={{
                        color: '#888888',
                        margin: '-60px 5px 14px 8px'
                      }}
                    >
                      ...
                    </div>
                    {showEditDetele && (
                      <div className="flex flex-col shadow rounded bg-white text-black-500 text-xs mt-1 more_option">
                        <div className="cursor-pointer hover:font-medium">
                          <img
                            src={delete_icon}
                            alt=""
                            className="inline-block pr-3"
                          />
                          <span
                            onClick={() => {
                              onDeleteOffer(index);
                              setShowEditDelete(false);
                            }}
                          >
                            Delete
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <span className="block p-1 px-2">
                    {each?.rateOfInterestOffer} % pa
                  </span>
                  <span className="block p-1 px-2">
                    ₹ {numberFormat(each?.EMI)}
                  </span>
                  <span className="block p-1 px-2">
                    ₹
                    {numberFormat(
                      parseInt(values?.loanAmountOffer) +
                        parseFloat(each?.additionalAmount)
                    )}
                  </span>
                </div>
              </React.Fragment>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};
export default AdditionalOffer;
